import {
  PriceCalculationMultiLegResultQuery,
  PriceCalculationMultiLegResultQueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";
import { CustomerResultData, PriceCalculatorFormData } from "../types/types";
import { fetchPriceCalculatorFragment } from "../gql/fragments";
import { transformToCustomerMultiLegResultData } from "../lib/transformers";

/**
 * Pass the customer arguments to have the result stored as the current
 * customer result. The booking flow calls this without them and keeps the
 * returned data instead.
 */
export const useMultiLegPriceCalculation = (
  formData?: PriceCalculatorFormData,
  setCustomerCalculatedState?: React.Dispatch<
    React.SetStateAction<PriceCalculatorFormData>
  >,
  setCustomerResult?: React.Dispatch<
    React.SetStateAction<CustomerResultData | undefined>
  >
) => {
  const multiLegPriceCalculationQuery = gql`
    ${fetchPriceCalculatorFragment}
    query PriceCalculationMultiLegResult($input: PriceCalculatorInput!) {
      priceCalculator {
        byMultiLegInput(variables: $input) {
          __typename
          ... on PriceCalculatorError {
            error
            errorType
          }
          ... on PriceCalculatorMultiLeg {
            list {
              ...FetchPriceCalculator
            }
          }
        }
      }
    }
  `;
  const [calculateMultiLegPrice, { loading, data, error }] = useLazyQuery<
    PriceCalculationMultiLegResultQuery,
    PriceCalculationMultiLegResultQueryVariables
  >(multiLegPriceCalculationQuery, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (formData && setCustomerCalculatedState && setCustomerResult) {
        setCustomerCalculatedState(formData);
        setCustomerResult(transformToCustomerMultiLegResultData(data));
      }
    },
  });

  return {
    calculateMultiLegPrice,
    loading,
    data,
    error,
  };
};
